import ActiveService from '@/service.active';


class PasswordService extends ActiveService{

  /**
   *
   * @param $injector
   * @param CONFIG
   * @param $translates
   */
  constructor(
    $injector,
    CONFIG,
    $translates,
    $auth,
    $httpConfigurator,
    $state
  ) {
    'ngInject';
    super($injector);
    this.CONFIG       = CONFIG;
    this.$translates  = $translates;
    this.$auth        = $auth;
    this.$httpConfigurator = $httpConfigurator;
    this.$state             = $state;
  }

  /**
   *
   * @param data
   * @returns {Function}
   */
  request( data ){
    return this.activePost( this.CONFIG.API.passwordResets , data )
      .then(() => this.notify.set(this.$translates.get('PASSWORD_REQUEST_SUCCESS'), 'success'));
  }

  reset( data ){
    let deferred = this.$q.defer();
    this.$http({
        url     : '/api/users/me',
        method  : 'GET',
        headers : {'X-RapidGAE-Magic-Link': data.token}
      })
      .then(response => {
        this.$httpConfigurator.setHeaders(
          response.headers('x-rapidgae-session-user')
        );
        this.activePut( response.data.uri, {
          password: data.password
        } )
        .then( () => this.$auth.authenticate({email: response.data.email,password: data.password}) )
        .then(()=> this.$state.go('booking', {target:'working'}))
        deferred.resolve();
      })
      .catch(() => deferred.reject());
    return deferred.promise;
  }
}

export default PasswordService;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/password/password.service.js
 **/